import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { LogIn } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password
    });

    if (error) {
      setError(error.message);
    } else {
      navigate('/');
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-black p-4 flex items-center justify-center">
      <div className="w-full max-w-md">
        <div className="bg-zinc-900 rounded-xl shadow-lg overflow-hidden border border-zinc-800 p-6">
          
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img 
              src="https://creativemedia.sg/wp-content/uploads/2024/04/CreativeMedia-White-Logo-No-Padding.svg"
              alt="CreativeMedia Singapore"
              className="h-12"
            />
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            
            {/* Error */}
            {error && (
              <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4 text-red-500 text-sm">
                {error}
              </div>
            )}

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-zinc-300 mb-2">
                Email address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-zinc-800 text-white px-4 py-2 rounded-lg placeholder-zinc-400 focus:outline-none focus:ring-2 focus:ring-white/20"
                placeholder="Enter your email"
                required
              />
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-zinc-300 mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-zinc-800 text-white px-4 py-2 rounded-lg placeholder-zinc-400 focus:outline-none focus:ring-2 focus:ring-white/20"
                placeholder="Enter your password"
                required
              />
            </div>

            {/* Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-black h-10 rounded-lg flex items-center justify-center gap-2 hover:bg-zinc-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <LogIn size={18} />
              {loading ? 'Loading...' : 'Sign In'}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}